import React from 'react';
import {
    Box,
    Paper,
    Typography,
    Button,
    TextField,
    Stack,
    Divider,
    Container
} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

const LoginPage = () => {
    // This now correctly builds the absolute URL to your backend.
    // In development, it will be "http://localhost:8080/oauth2/authorization/google".
    // In production, when this variable is not set, it will correctly resolve to "/oauth2/authorization/google".
    const googleLoginUrl = `${process.env.REACT_APP_API_BASE_URL || ''}/oauth2/authorization/google`;

    return (
        <Container component="main" maxWidth="xs" sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh'
        }}>
            <Paper elevation={4} sx={{padding: 4, width: '100%'}}>
                <Stack spacing={2} alignItems="center">
                    {/* Placeholder for your Nexal Games logo */}
                    <Typography variant="h4" component="h1" gutterBottom>
                        Nexal Games
                    </Typography>
                    <Typography variant="h5" component="h1" gutterBottom>
                        Admin Panel
                    </Typography>

                    <Box sx={{width: '100%', pt: 1}}>
                        {/* The SSO Login Button */}
                        <Button
                            fullWidth
                            variant="contained"
                            startIcon={<GoogleIcon/>}
                            component="a"
                            href={googleLoginUrl}
                            sx={{textTransform: 'none', fontSize: '1rem'}}
                        >
                            Sign in with Google
                        </Button>
                    </Box>

                    <Divider sx={{width: '100%', my: 2}}>OR</Divider>

                    {/* Placeholder for future Login/Password form */}
                    <Box component="form" sx={{width: '100%'}}>
                        <Stack spacing={2}>
                            <TextField
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                disabled // Disabled for now
                            />
                            <TextField
                                name="password"
                                label="Password"
                                type="password"
                                autoComplete="current-password"
                                disabled // Disabled for now
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="outlined"
                                sx={{mt: 1}}
                                disabled // Disabled for now
                            >
                                Sign In
                            </Button>
                        </Stack>
                    </Box>
                </Stack>
            </Paper>
        </Container>
    );
};

export default LoginPage;